import { Drawer as DrawerPrimitive } from "vaul";

import Content from "./Content";
import Overlay from "./Overlay";
import Root from "./Root";

export const Drawer: {
  Root: typeof Root;
  Trigger: typeof DrawerPrimitive.Trigger;
  Portal: typeof DrawerPrimitive.Portal;
  Close: typeof DrawerPrimitive.Close;
  Content: typeof Content;
  Overlay: typeof Overlay;
} = {
  Root,
  Trigger: DrawerPrimitive.Trigger,
  Portal: DrawerPrimitive.Portal,
  Close: DrawerPrimitive.Close,
  Content,
  Overlay,
};

export type { DrawerRootProps } from "./Root";
